import { put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { data as responseData } from './data';
//import { prepareFilters } from '../../components/Filters/request';
import { handleErrors } from '../../api';

function* getNotifications(/*{ payload: { filters } }*/) {
  try {
    
    // const responseData = yield call(fetch, api.analytic);
    yield put(actions.getNotificationsDone(responseData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getNotificationsFailed
    });
  }
}

export const getNotificationsSaga = takeEvery(types.GET_NOTIFICATIONS_REQUEST, getNotifications);